<template>
  <div class="row border-bottom">
    <nav
      class="navbar navbar-static-top"
      role="navigation"
      style="margin-bottom: 0"
    >
      <ul class="nav navbar-top-links navbar-right">
        <li id="change-language">
          <i
            class="fa fa-globe fa-fw"
            style="color: #999c9e; font-weight: 600"
          />
          <span>
            <a
              style="color: #999c9e; font-weight: 600"
              @click="changeLang('en')"
            >
              EN
            </a>
          </span>
          |
          <span>
            <a
              style="color: #999c9e; font-weight: 600"
              @click="changeLang('pt-BR')"
            >
              PT
            </a>
          </span>
        </li>
        <li v-if="ExibeConfigDashboard">
          <router-link
            :to="{ name: 'config-dashboard-index' }"
            @click="change()"
          >
            <i class="fa fa-cog fa-fw" />
            {{ $t('dashboard_config') }}
          </router-link>
        </li>
        <li id="change-profile">
          <a @click="change()">
            <i class="fa fa-user-circle-o fa-fw" />
            {{ $t('switch_institute') }}
          </a>
        </li>
        <li id="edit-profile">
          <a @click="loadUserData">
            <i class="fa fa-pencil-square-o fa-fw" />
            {{ $t('edit_profile') }}
          </a>
        </li>
        <li id="help-button">
          <a @click="openHelp()">
            <i class="fa fa-question-circle fa-fw" />
            {{ $t('help') }}
          </a>
        </li>
        <li id="logout">
          <a @click="logout()">
            <i class="fa fa-sign-out fa-fw" />
            {{ $t('logout') }}
          </a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      id="profileModal"
      class="modal fade"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 id="myModalLabel" class="modal-title">
              {{ $t('edit_user_profile') }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div
                  class="form-group"
                  :class="{ 'has-error': errors.has('nome') }"
                >
                  <label for="nome">{{ $t('name') }}</label>
                  <input
                    id="nome"
                    v-model="Nome"
                    v-validate="'required|min:2'"
                    type="text"
                    class="form-control"
                    name="nome"
                  />
                  <span v-show="errors.has('nome')" class="text-danger">
                    {{ errors.first('nome') }}
                  </span>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="form-group"
                  :class="{ 'has-error': errors.has('telefone') }"
                >
                  <label for="telefone">{{ $t('phone') }}</label>
                  <input
                    id="telefone"
                    v-model="Telefone"
                    v-validate="'required|min:2'"
                    type="text"
                    class="form-control"
                    name="telefone"
                  />
                  <span v-show="errors.has('telefone')" class="text-danger">
                    {{ errors.first('telefone') }}
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="pais">{{ $t('country') }}</label>
                  <select2
                    v-if="reloadPais"
                    :options="paisOptions"
                    :change="setPais"
                  >
                    <option :value="PaisId">{{ PaisNome }}</option>
                  </select2>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="estado">{{ $t('state') }}</label>
                  <select2
                    v-if="reloadEstado"
                    :disable="!PaisId"
                    :options="estadoOptions"
                    :change="setEstado"
                  >
                    <option :value="EstadoId">{{ EstadoNome }}</option>
                  </select2>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="cidade">{{ $t('city') }}</label>
                  <select2
                    v-if="reloadCidade"
                    :disable="!EstadoId"
                    :options="cidadeOptions"
                    :change="setCidade"
                  >
                    <option :value="CidadeId">{{ CidadeNome }}</option>
                  </select2>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-white" data-dismiss="modal">
              {{ $t('close') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">
              {{ $t('save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { Select2 } from '../shared'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TopNavbar',
  props: ['logout', 'change'],
  components: {
    Select2
  },
  created() {
    if ($(window).width() < 769) {
      $('body').toggleClass('body-small')
    }

    $(window).bind('load resize', function() {
      $(this).width() < 769
        ? $('body').addClass('body-small')
        : $('body').removeClass('body-small')
    })
  },
  computed: {
    ...mapGetters('usuarioRestrita/edit', ['data']),
    ExibeConfigDashboard() {
      if (process.env.VUE_APP_FEATURE_CONFIG_DASHBOARD === 'disabled')
        return false

      const data = window.localStorage.getItem('imea.portal.userinfo')

      if (data) {
        const obj = JSON.parse(data)
        return obj && obj.GerenciaDashboard
      }

      return undefined
    }
  },
  methods: {
    ...mapActions('usuarioRestrita/edit', ['submitData', 'requestData']),
    changeLang(lang) {
      localStorage.setItem('locale', lang)
      location.reload()
    },
    openHelp() {
      const child = this.$root.$children[0].$children[0].$children.find(
        child => {
          const { methods } = child.$options
          if (methods) {
            return methods.help
          } else {
            return false
          }
        }
      )

      if (child) {
        child.help()
      }
    },
    loadUserData() {
      this.requestData().then(() => {
        this.Nome = this.data.Nome
        this.Telefone = this.data.Telefone
        this.PaisId = this.data.PaisId
        this.EstadoId = this.data.EstadoId
        this.CidadeId = this.data.CidadeId
        this.PaisNome = this.data.PaisNome
        this.EstadoNome = this.data.EstadoNome
        this.CidadeNome = this.data.CidadeNome
        this.refreshPais()
        this.refreshEstado()
        this.refreshCidade()
        $('#profileModal').modal()
      })
    },
    setPais({ id }) {
      this.PaisId = id
      this.EstadoId = ''
      this.CidadeId = ''
      this.refreshEstado()
      this.refreshCidade()
      this.estadoOptions = {
        placeholder: 'Selecione um Estado',
        url: `/estado?pais=${id}`
      }
    },
    setEstado({ id }) {
      this.EstadoId = id
      this.CidadeId = ''
      this.refreshCidade()
      this.cidadeOptions = {
        placeholder: 'Selecione uma Cidade',
        url: `/cidade?estado=${id}`
      }
    },
    setCidade({ id }) {
      this.CidadeId = id
    },
    refreshPais() {
      this.reloadPais = false
      setTimeout(() => {
        this.reloadPais = true
      })
    },
    refreshEstado() {
      this.reloadEstado = false
      setTimeout(() => {
        this.reloadEstado = true
      })
    },
    refreshCidade() {
      this.reloadCidade = false
      setTimeout(() => {
        this.reloadCidade = true
      })
    },
    submit() {
      this.$validator
        .validateScopes()
        .then(() => {
          const Nome = this.Nome
          const PaisId = this.PaisId
          const EstadoId = this.EstadoId
          const CidadeId = this.CidadeId
          const Telefone = this.Telefone
          this.submitData({ Nome, PaisId, EstadoId, CidadeId, Telefone }).then(
            () => {
              $('#profileModal').modal('hide')
            }
          )
        })
        .catch(() => {})
    },

    minimalize() {
      $('body').toggleClass('mini-navbar')
      if (
        !$('body').hasClass('mini-navbar') ||
        $('body').hasClass('body-small')
      ) {
        $('#side-menu').hide()
        setTimeout(() => {
          $('#side-menu').fadeIn(500)
        }, 100)
      } else if ($('body').hasClass('fixed-sidebar')) {
        $('#side-menu').hide()
        setTimeout(() => {
          $('#side-menu').fadeIn(500)
        }, 300)
      } else {
        $('#side-menu').removeAttr('style')
      }
    }
  },
  data() {
    return {
      Nome: '',
      PaisId: '',
      EstadoId: '',
      CidadeId: '',
      Telefone: '',
      PaisNome: '',
      EstadoNome: '',
      CidadeNome: '',
      reloadPais: true,
      reloadEstado: true,
      reloadCidade: true,

      paisOptions: {
        placeholder: 'Selecione um País',
        url: '/pais'
      },
      estadoOptions: {
        placeholder: 'Selecione um Estado',
        url: '/estado'
      },
      cidadeOptions: {
        placeholder: 'Selecione uma Cidade',
        url: '/cidade'
      }
    }
  }
}
</script>
